import { EDescriptionQualityReason } from 'partner360/entities/keyInitiatives'

export enum EDescriptionQualityBand {
  Insufficient = 'insufficient',
  Weak = 'weak',
  Good = 'good',
  Strong = 'strong',
}

export const BAND_THRESHOLDS: { band: EDescriptionQualityBand; min: number }[] = [
  { band: EDescriptionQualityBand.Strong, min: 80 },
  { band: EDescriptionQualityBand.Good, min: 62 },
  { band: EDescriptionQualityBand.Weak, min: 45 },
  { band: EDescriptionQualityBand.Insufficient, min: 0 },
]

export interface IDescriptionQualityResult {
  score: number
  reasons: EDescriptionQualityReason[]
}

export interface IDescriptionQualityInitiative {
  Name: string
  Description: string
}
